"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = validate;
exports.validateAccount = validateAccount;
const SEValidator_class_1 = require("./SEValidator.class");
const seValidator = new SEValidator_class_1.SEValidator();
function validate(number, opt = {}) {
    return seValidator.isValidBankAccountWhenBankUnknown(number, opt);
}
function validateAccount(clearningNumber, accountNumber, opt = { normalize: false }) {
    return validate(clearningNumber + accountNumber, opt) !== false;
}
